import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import TextFieldsIcon from "@mui/icons-material/TextFields";
import DescriptionIcon from "@mui/icons-material/Description";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import PersonIcon from "@mui/icons-material/Person";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import SearchIcon from "@mui/icons-material/Search";

import Introduction from "./components/Introduction";
import SearchForm from "./components/SearchForm";

import NavigationFooter from "../../helper-components/misc/NavigationFooter";
import CustomForm from "../../helper-components/form/CustomForm";

import { getLanguage } from "../../config/language/language";

/**
 * The homepage.
 */
export default function Home(props) {
    const isLoggedIn = props.user.isLoggedIn;

    const title = isLoggedIn ? getLanguage().SEARCH_TITLE : getLanguage().HOME_OVERVIEW_TITLE;
    const subtitle = isLoggedIn ? getLanguage().SEARCH_SUBTITLE : getLanguage().HOME_OVERVIEW_SUBTITLE;
    const icon = isLoggedIn ? <SearchIcon /> : <ViewQuiltIcon />;

    return (
        <Container maxWidth="xl" sx={{ mb: 2, mt: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12} className="tour-about-4">
                    <CustomForm title={title} subtitle={subtitle} icon={icon} />
                </Grid>

                {!isLoggedIn && <Introduction {...props} />}

                {isLoggedIn && <SearchForm {...props} />}

                {isLoggedIn && (
                    <NavigationFooter
                        rows={2}
                        options={[
                            {
                                path: `/database/resources`,
                                title: "Resources",
                                variant: "outlined",
                                icon: <DescriptionIcon />
                            },
                            {
                                path: `/database/transcripts`,
                                title: "Transcripts",
                                variant: "outlined",
                                icon: <TextFieldsIcon />
                            },
                            {
                                path: `/database/quotes`,
                                title: "Quotes",
                                variant: "outlined",
                                icon: <FormatQuoteIcon />
                            },
                            {
                                path: `/database/authors`,
                                title: "Authors",
                                variant: "outlined",
                                icon: <PersonIcon />
                            }
                        ]}
                    />
                )}
            </Grid>
        </Container>
    );
}
